// React
import React, { useMemo } from 'react'
import { Provider } from 'react-redux'

const withStore = (Component) => (props) => {
  const store = useMemo(() => window.booqableGetStore(), [])

  return (
    <Provider store={store}>
      <Component {...props} />
    </Provider>
  )
}

export default withStore
